// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"5e2ce28d","260":"793e9416","455":"626c7cf2","977":"7381645d"}[chunkId] + ".chunk.js";
};